<template>
    <div>
        <button-toggle :style="{ backgroundColor: value ? colorActive : colorInactive }" :class="buttonClass"
            @click="handleClick">
            <span v-if="value" class="icon-button-toggle"><i :class="classIconActive"></i></span>
            <span v-else class="icon-button-toggle"><i :class="classIconInactive"></i></span>
            <span v-if="value">{{ titleActive }}</span>
            <span v-else="value">{{ titleInactive }}</span>
        </button-toggle>
    </div>
</template>

<script>
export default {
    name: 'ToggleButton',
    props: {
        titleActive: String,
        classIconActive: String,
        colorActive: String,
        titleInactive: String,
        classIconInactive: String,
        colorInactive: String,
        value: Number,
        disabled: Boolean
    },
    computed: {
        buttonClass() {
            return {
                'button-toggle': true,
                'button-toggle--value': this.value,
                'button-toggle--inactive': !this.value,
                'button-toggle-disabled': this.disabled
            };
        },
    },
    methods: {
        handleClick() {
            if (!this.disabled) {
                this.value = this.value == true ? false : true;
                this.$emit("input", this.value);
            }
        }
    }
}
</script>

<style scoped>
.button-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 3px 15px;
    border: none;
    border-radius: 20px;
    font-size: 13px;
    cursor: pointer;
    transition: background-color 0.3s, color 0.3s;
}

.button-toggle--value {
    color: white;
}

.button-toggle--inactive {
    color: black;
}

.icon-button-toggle {
    margin-right: 8px;
}

.button-toggle-disabled {
    background-color: #b0b0b0;
    opacity: 0.5;
    cursor: not-allowed;
}
</style>